export default "__VITE_ASSET__C4v1ka9L__"